<template>
    <div>
        <div class="row align-items-center">
            <div class="col-12 col-md-6 col-lg-3 my-1">
                <div class="dropdown-curve-container">
                    <label :class="selectedCinema['cine_id'] ? 'shift-up' : ''">
                        Cinema
                    </label>
                    <multiselect v-model="selectedCinema" :options="cinemaData" :placeholder="$tc('Cinemas')"
                        label="cine_name" track-by="cine_id"></multiselect>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 my-1">
                <div class="input-material">
                    <div class="add-datepicker custom-date">
                        <label :class="fromDate ? 'active' : ''">
                            Reservation From
                        </label>
                        <Datepicker :monday-first="true" ref="programaticOpen" v-model="fromDate" type="date"
                            class="theme-custom-date-time w-100" typeable id="fromDate" name="fromDate"
                            v-b-tooltip.hover></Datepicker>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 my-1">
                <div class="input-material">
                    <div class="add-datepicker custom-date">
                        <label :class="toDate ? 'active' : ''">
                            Reservation To
                        </label>
                        <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate" type="date"
                            :not-after="disabledAfter" :disabledDates="disabledDates"
                            class="theme-custom-date-time w-100" typeable id="toDate" name="toDate" v-b-tooltip.hover>
                        </Datepicker>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 my-1">
                <div class="dropdown-curve-container">
                    <label :class="selectedPaymentFilter['value'] ? 'shift-up' : ''">
                        Payment Filters
                    </label>
                    <multiselect v-model="selectedPaymentFilter" :options="paymentFilters" label="label"
                        track-by="value"></multiselect>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 my-1">
                <div class="input-material">
                    <input v-model="searchValue" placeholder="Search by email, phone, reservation, order-code" />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-3 my-1">
                <button class="btn-blue-lg w-100" @click="fetchFnbOnlyPayments">Fetch Report</button>
            </div>
            <!-- <div class="col-lg-6 col-xl-3 align-self-center mb-3">
                <button :disabled="btenable" class="btn-blue-lg w-100" @click.prevent.stop="fetchFnbOnlyPayments('Y')">
                    {{ $tc("fetch") }} {{ $tc("report") }}
                </button>
            </div> -->

            <div class="col-lg-6 col-xl-2 d-flex justify-content-end" v-if="fnbOnlyData.length">
                <div class="mx-1">{{ $t("download") }} as:</div>
                <a target="_blank" @click="fetchFnbOnlyPayments('Y')" title="Download as Excel" style="cursor: pointer"
                    download>
                    <img class="mx-1" src="@/assets/img/icons/excel.svg" height="25" width="25" />
                </a>
            </div>
        </div>
        <div class="swc-report" style="overflow-x: scroll; width: auto !important">
            <table border="1" class="swc-report-table mb-3">
                <thead class="custom_sticky_header bg-lightgrey">
                    <tr>
                        <th>{{ $tc("Reservation ID") }}</th>
                        <th>{{ $tc("Cinema Name") }}</th>
                        <th>F&B Name</th>
                        <th>{{ $tc("customer") }} {{ $tc("email") }}</th>
                        <th>{{ $tc("customer") }} {{ $tc("Number") }}</th>
                        <th>{{ $tc("Booking") }} {{ $tc("Source") }}</th>
                        <th>
                            {{ $tc("reservation") }} {{ $tc("date") }} & {{ $tc("time") }}
                        </th>
                        <th>
                            Fnb Booking Date &
                            {{ $tc("time") }}
                        </th>
                        <th>Order Code</th>
                        <th>{{ "Pickup Code" }}</th>
                        <th>{{ $tc("Payment Status") }}</th>
                        <th>{{ $tc("Booking Status") }}</th>
                        <th>{{ "Card" }}</th>
                        <th>{{ "Card Number" }}</th>
                        <th>{{ "Name on Card" }}</th>
                        <th>{{ "Authorization Code" }}</th>
                        <th>{{ "RRN" }}</th>
                        <th>{{ "STAN" }}</th>
                        <th>{{ "Reserve Amount" }}</th>
                        <th>{{ "Amount" }}</th>
                        <th>{{ $tc("refund") }} {{ $t("Status") }}</th>
                        <!-- <th>{{ $tc("refund") }} {{ $t("Approved By") }}</th> -->
                        <th>{{ $tc("refund") }} {{ $t("Time") }}</th>
                        <th>{{ "Inquiry" }}</th>
                        <th>{{ "Action" }}</th>
                    </tr>
                </thead>

                <tbody v-if="fnbOnlyData && fnbOnlyData.length">
                    <tr v-for="(fnbDataObj, fnbDataObjIndex) in fnbOnlyData" :key="fnbDataObjIndex">
                        <td class="text-left">{{ fnbDataObj.reservation_id }}</td>
                        <td class="text-left">{{ fnbDataObj.cinema_name }}</td>
                        <td class="text-left">{{ fnbDataObj.item_name }}</td>
                        <td class="text-left">{{ fnbDataObj.email }}</td>
                        <td class="text-left">{{ fnbDataObj.mobile }}</td>
                        <td class="text-left">{{ fnbDataObj.booking_source_name }}</td>
                        <td class="text-left">{{ fnbDataObj.reservation_time }}</td>
                        <td class="text-left">{{ fnbDataObj.booking_time || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.order_code || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.pickup_code || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.transaction_status || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.status || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.card_type || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.card_no || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.card_holder_name || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.auth_code || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.rrn || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.stan || "-" }}</td>
                        <td class="text-right">{{ currFormat(fnbDataObj.amount) || "-" }}</td>
                        <td class="text-right">{{ currFormat(fnbDataObj.amount) || "-" }}</td>
                        <td class="text-left">{{ fnbDataObj.refund_date_time ? 'Y' : 'N' }}</td>
                        <td class="text-left">{{ fnbDataObj.refund_date_time || "-" }}</td>
                        <td class="text-center"><button class="btn-blue"
                                @click="alrajhiPaymentInquiry({ reservation_id: fnbDataObj.reservation_id, cinema_id: fnbDataObj.cinema_id, amount: fnbDataObj.amount })">Inquiry</button>
                        </td>
                        <td class="text-center"><button class="btn-blue"
                                v-if="!fnbDataObj.refund_date_time && ['1', '2'].includes(String(selectedPaymentFilter['value']))"
                                @click="handleRefundProcess({ order_code: fnbDataObj['order_code'], reservation_id: fnbDataObj['reservation_id'] })">Refund</button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="23">
                            <NoRecords />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <ManagerAuthLogin :moduleName="'FnbOnlyPGRefund'" :onCheckAuth="handleAuthCheck"
            :refId="'fnb_only_authManager_PGRefund'" />
    </div>
</template>

<script>
import NewReportService from "@/services/NewReportService";
import moment from "moment"
import NoRecords from "@/components/Partials/NoRecords.vue";
import ManagerAuthLogin from "@/components/Partials/AuthManagerLoginPopup";
import PosService from "@/services/PosService";
import PosFnbService from "@/services/PosFnbService.js";


export default {
    components: { NoRecords, ManagerAuthLogin },
    props: {
        cinemaData: {
            type: Array,
            default: () => {
                return []
            }
        },
        emitInquiryDetails: {
            type: Object,
            default: () => {
                return {}
            }
        },
        emitTicketDetails: {
            type: String,
            default: ""
        },
        is_auth_needed: {
            type: String,
            default: "Y"
        },
        refundReasonsData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        return {
            fnbOnlyData: [],
            selectedCinema: { cine_id: null },
            fromDate: new Date(),
            toDate: new Date(),
            disabledAfter: new Date(),
            searchValue: "",
            paymentFilters: [{ value: 1, label: "Payment Success | Booking Success" }, { value: 2, label: "Payment Success | Booking Failed" }, { value: 3, label: "Pending" }, { value: 4, label: "All" }],
            selectedPaymentFilter: { value: 1, label: "Payment Success | Booking Success" },
            toRefundItemsList: [],
            toRefundOrderCode: "",
            toRefundReservationId: "",
            skipAuth: false,
            disabledDates: {
                from: "",
            },
        }
    },
    watch: {
        selectedPaymentFilter(newVal) {
            this.fnbOnlyData = []
        },
        fromDate: function (value) {
            if (this.selectedPaymentFilter['value'] == 4) {
                this.toDate = moment(this.fromDate).add(1, 'days').format("YYYY-MM-DD");
                this.disabledDates.from = moment(this.fromDate).add(15, 'days').toDate();
                console.log(this.disabledDates.from, " this.disabledDates.from ")
            } else {
                this.toDate = moment(this.fromDate).add(1, 'days').format("YYYY-MM-DD");
                this.disabledDates.from = moment(this.fromDate).add(30, 'days').toDate();
                console.log(this.disabledDates.from, " this.disabledDates.from ")
            }
        }
    },
    beforeMount() {
        console.log({ cinemaData: this.cinemaData, refundReasonsData: this.refundReasonsData })
        this.handleDateRanges()
    },
    methods: {
        handleDateRanges() {
            if (this.selectedPaymentFilter['value'] == 4) {
                this.toDate = moment(this.fromDate).add(1, 'days').format("YYYY-MM-DD");
                this.disabledDates.from = moment(this.fromDate).add(15, 'days').toDate();
                console.log(this.disabledDates.from, " this.disabledDates.from ")
            } else {
                this.toDate = moment(this.fromDate).add(1, 'days').format("YYYY-MM-DD");
                this.disabledDates.from = moment(this.fromDate).add(30, 'days').toDate();
                console.log(this.disabledDates.from, " this.disabledDates.from ")
            }
        },
        fetchFnbOnlyPayments: async function (isExcel = 'N') {
            if (!this.selectedCinema || !this.selectedCinema["cine_id"]) {
                return this.$toasted.show("Please select cinema")
            }
            let loader = this.$loading.show();
            this.fnbOnlyData = []
            try {
                const payload = {
                    fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
                    toDate: moment(this.toDate).format("YYYY-MM-DD"),
                    cinema_id: this.selectedCinema['cine_id'],
                    searchValue: this.searchValue,
                    paymentFilter: this.selectedPaymentFilter['value'],
                    isExcel
                }

                if (isExcel == "Y") {
                    payload["cinema_address"] = this.selectedCinema['cine_address'] || "-"
                    payload["cinema_name"] = this.selectedCinema['cine_name'] || "-"
                }
                const response = await NewReportService.GetFnbOnlyPaymentsData(payload)

                const { data } = response || {}

                if (!data || !data.status || !data.Records.length) {
                    return this.$toasted.show(data["message"] || "Something went wrong")
                }

                this.fnbOnlyData = data.Records

                if (data.excelPath) {
                    window.open(data.excelPath, "_blank")
                }
            } catch (error) {
                console.log(error)
            } finally {
                loader.hide();
            }
        },
        alrajhiPaymentInquiry: async function (reservationData) {
            let loader = this.$loading.show();
            try {
                const response = await PosService.AlrajhiInquiryPayment({
                    cinema_id: reservationData['cinema_id'],
                    currency: 'SAR',
                    reservation_id: reservationData.reservation_id,
                    amount: reservationData.amount
                })
                let error = this.getSafe(() => response.data.error, {});
                let trandata = this.getSafe(() => response.data.trandata, {});
                this.$emit("emitInquiryDetails", Object.assign({}, error, { trandata }))
            } catch (error) {
                console.log(error)
            } finally {
                loader.hide();

            }
        },
        fetchFnbOrderDetailsToRefund: async function (reservationData) {
            // let loader = this.$loading.show();
            this.toRefundItemsList = []
            this.toRefundOrderCode = reservationData.order_code
            try {
                const response = await PosService.GetFnbOrderDetails({ order_code: this.toRefundOrderCode })

                const { data } = response || {}

                if (!data || !data.status || !data.Records || !data.Records.length) {
                    return this.$toasted.show("Fnb Data not found")
                }

                this.toRefundItemsList = data.Records.filter(
                    x => x.refund_datetime == null && x.is_refund == "N"
                );
            } catch (error) {
                console.log(error)
            }
        },
        handleAuthCheck: async function (response) {
            const { valid, name } = response;
            console.log({ response })
            if (valid) {
                if (name == "FnbOnlyPGRefund") {
                    this.skipAuth = true;
                    this.$bvModal.hide("fnb_only_authManager_PGRefund");
                    this.handleRefundProcess({ order_code: this.toRefundOrderCode, reservation_id: this.toRefundReservationId });
                }
            }
        },

        handleRefundProcess: async function (reservationData) {
            let loader = this.$loading.show()
            this.toRefundOrderCode = reservationData.order_code
            this.toRefundReservationId = reservationData.reservation_id
            try {
                if (this.toRefundOrderCode) {
                    await this.fetchFnbOrderDetailsToRefund(reservationData)
                }
                if (this.is_auth_needed == "Y" && !this.skipAuth) {
                    this.$bvModal.show("fnb_only_authManager_PGRefund");
                } else {
                    const toRefundOrderDetails = this.fnbOnlyData.find(fnbObj => {
                        return fnbObj.reservation_id == reservationData.reservation_id
                    })
                    console.log({ toRefundOrderDetails, reservationData })
                    this.toRefundOrderCode = ""
                    this.toRefundReservationId = ""
                    if (!toRefundOrderDetails) {
                        return this.$toasted.show("No data found")
                    }
                    const payload = {
                        reservation_id: toRefundOrderDetails.reservation_id,
                        cinema_id: toRefundOrderDetails.cinema_id,
                        currency: 'SAR',
                        fort_id: "",
                        sr_id: toRefundOrderDetails.sr_id || "",
                        pm_payment_mode: "Al Rajhi Bank",
                        amount: toRefundOrderDetails.amount
                    }

                    const pgResponse = await PosService.PaymentGatewayRefundApi(payload)

                    if (!pgResponse.data || !pgResponse.data.status) {
                        return this.$toasted.show("PG refund failed.")
                    }

                    if (!this.toRefundItemsList.length) {
                        return this.$toasted.show("PG refund successful")
                    }

                    // const refundReasonResponse = await PosService.getRefundReason(payload);

                    // const refundReasons = []
                    // if (!refundReasonResponse || !refundReasonResponse.data || !refundReasonResponse.data.status) {
                    //     return this.$toasted.show("No refund reasons to attach")
                    // }

                    const currentRefundReason = this.refundReasonsData.filter(
                        x => String(x.rr_reason).toLowerCase() == "payment failure"
                    )[0] || this.refundReasonsData[0];

                    this.toRefundItemsList.forEach(refundItemsObj => {
                        refundItemsObj.refund_reason = currentRefundReason.rr_reason;
                        refundItemsObj.refund_payment_mode_id = 22; //to refund payment mode id
                        refundItemsObj.is_refund = "Y";
                    })

                    const refundResponse = await PosService.fnbRefund({
                        fnbRefundList: this.toRefundItemsList,
                        cinema_id: toRefundOrderDetails.cinema_id
                    })

                    if (!refundResponse.data || !refundResponse.data.status) {
                        return this.$toasted.show("Refund failed")
                    }

                    this.$toasted.show("FnB Order Refunded")
                    this.fetchFnbOnlyPayments()

                    // const ticketResponse = await PosFnbService.GetFnbRefundEjs({
                    //     OrderCode: reservationData.order_code,
                    //     Type: "Print",
                    //     UserID: toRefundOrderDetails["created_by"],
                    //     isReprint: false,
                    //     isRefund: true
                    // })

                    // if (ticketResponse.data) {
                    //     this.$emit("emitTicketDetails", ticketResponse.data)
                    // }

                }
            } catch (error) {
                console.log(error)
            } finally {
                loader.hide()
            }
        }
    }
}
</script>
<style scoped>
.custom_sticky_header {
    position: sticky;
    top: -1px;
    /* background: #fff; */
}
</style>


// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/PaymentGatewayRefund/FnbOnlyPaymentGatewayRefund.vue